export const NavItems = [
    {
        id:1,
        title:"Home",
        path:"/",
        cName:"navbar-link",
        onClick:"{()=>setMenuIcon(false)}",
        subMenu:[]
    },
    {
        id:2,
        title:"About Us",
        path:"/about",
        cName:"navbar-link",
        onClick:"{()=>setMenuIcon(false)}",
        subMenu:[
            {
                id:1,
                title:"Vision & Mission",
                path:"/vision",
                cName:"submenu-item",
                onClick:"{()=>setMenuIcon(false)}"
            },
            {
                id:2,
                title:"Management",
                path:"/management",
                cName:"submenu-item",
                onClick:"{()=>setMenuIcon(false)}"
            },
            {
                id:3,
                title:"PrinciapDesk",
                path:"/pdesk",
                cName:"submenu-item",
                onClick:"{()=>setMenuIcon(false)}"
            },
            {
                id:4,
                title:"Why HKC?",
                path:"/whyHKC",
                cName:"submenu-item",
                onClick:"{()=>setMenuIcon(false)}"
            }
        ]
    },
    {
        id:3,
        title:"Facilities",
        path:"/facilities",
        cName:"navbar-link",
        onClick:"{()=>setMenuIcon(false)}",
        subMenu:[
            {
                id:1,
                title:"Infrastructure",
                path:"/infra",
                cName:"submenu-item",
                onClick:"{()=>setMenuIcon(false)}"
            },
            {
                id:2,
                title:"Transport",
                path:"/transport",
                cName:"submenu-item",
                onClick:"{()=>setMenuIcon(false)}"
            }
        ]
    },
    {
        id:4,
        title:"Learning",
        path:"/learning",
        cName:"navbar-link",
        onClick:"{()=>setMenuIcon(false)}",
        subMenu:[
            {
                id:1,
                title:"Curriculum & Sports",
                path:"/curriculum",
                cName:"submenu-item",
                onClick:"{()=>setMenuIcon(false)}"
            },
            {
                id:2,
                title:"Cocurricular Activities",
                path:"/cocurriculum",
                cName:"submenu-item",
                onClick:"{()=>setMenuIcon(false)}"
            },
            {
                id:3,
                title:"Learning beyond the classroom",
                path:"/learningbeyond",
                cName:"submenu-item",
                onClick:"{()=>setMenuIcon(false)}"
            },
            {
                id:4,
                title:"Faculty",
                path:"/faculty",
                cName:"submenu-item",
                onClick:"{()=>setMenuIcon(false)}"
            },
            {
                id:5,
                title:"Academic Calendar",
                path:"/calender",
                cName:"submenu-item",
                onClick:"{()=>setMenuIcon(false)}"
            }
        ]
    },
    {
        id:5,
        title:"Admission",
        path:"/admission",
        cName:"navbar-link",
        onClick:"{()=>setMenuIcon(false)}",
        subMenu:[]
    },
    {
        id:6,
        title:"Gallery",
        path:"/gallery",
        cName:"navbar-link",
        onClick:"{()=>setMenuIcon(false)}",
        subMenu:[]
    },
    {
        id:7,
        title:"Contact Us",
        path:"/contact",
        cName:"navbar-link",
        onClick:"{()=>setMenuIcon(false)}",
        subMenu:[]
    },
]

export const AboutUs=[
    {
        id:1,
        title:"Vision & Mission",
        path:"/vision",
        cName:"submenu-item",
        onClick:"{()=>setMenuIcon(false)}"
    },
    {
        id:2,
        title:"Management",
        path:"/management",
        cName:"submenu-item",
        onClick:"{()=>setMenuIcon(false)}"
    },
    {
        id:3,
        title:"PrinciapDesk",
        path:"/pdesk",
        cName:"submenu-item",
        onClick:"{()=>setMenuIcon(false)}"
    },
    {
        id:4,
        title:"Why HKC?",
        path:"/whyHKC",
        cName:"submenu-item",
        onClick:"{()=>setMenuIcon(false)}"
    }
]


export const Facilities = [
    {
        id:1,
        title:"Infrastructure",
        path:"/infra",
        cName:"submenu-item",
        onClick:"{()=>setMenuIcon(false)}"
    },
    {
        id:2,
        title:"Transport",
        path:"/transport",
        cName:"submenu-item",
        onClick:"{()=>setMenuIcon(false)}"
    }
] 

export const Learning = [
    {
        id:1,
        title:"Curriculum & Sports",
        path:"/curriculum",
        cName:"submenu-item",
        onClick:"{()=>setMenuIcon(false)}"
    },
    {
        id:2,
        title:"Cocurricular Activities",
        path:"/cocurriculum",
        cName:"submenu-item",
        onClick:"{()=>setMenuIcon(false)}"
    },
    {
        id:3,
        title:"Learning beyond the classroom",
        path:"/learningbeyond",
        cName:"submenu-item",
        onClick:"{()=>setMenuIcon(false)}"
    },
    {
        id:4,
        title:"Faculty",
        path:"/faculty",
        cName:"submenu-item",
        onClick:"{()=>setMenuIcon(false)}"
    },
    {
        id:5,
        title:"Academic Calendar",
        path:"/calender",
        cName:"submenu-item",
        onClick:"{()=>setMenuIcon(false)}"
    }
]